import type { DynamicClient } from '../../../client/types';
import { NoWalletProviderFoundError } from '../../../errors/NoWalletProviderFoundError';
import { getWalletProviders } from '../getWalletProviders';

type GetWalletProviderByKeyParams = {
  walletProviderKey: string;
};

export const getWalletProviderByKey = (
  { walletProviderKey }: GetWalletProviderByKeyParams,
  client: DynamicClient
) => {
  const walletProviders = getWalletProviders(client);

  const walletProvider = walletProviders.find(
    (walletProvider) => walletProvider.key === walletProviderKey
  );

  if (!walletProvider) {
    throw new NoWalletProviderFoundError({ walletProviderKey });
  }

  return walletProvider;
};
